import styled from "styled-components/macro";
import { BREAKPOINT_MOBLET } from "../../../constants/constants";
const ROW_LABEL_COLUMN_WIDTH = 20;
const DAY_COLUMN_WIDTH = 10;
const TOTAL_COLUMN_WIDTH = 100 - 7 * DAY_COLUMN_WIDTH - ROW_LABEL_COLUMN_WIDTH;

export const backgroundColors = [
  "rgba(39, 170, 225, 0.25)",
  "rgba(230, 231, 232)",
];

export const ColumnHeaderStyles = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-grow: 0;
  font-size: 24pt;
  box-sizing: border-box;

  @media (max-width: ${BREAKPOINT_MOBLET}px) {
    font-size: 14pt;
  }
`;

export const SimpleRowStyles = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  font-size: 16pt;
  box-sizing: border-box;
  padding-right: 1%;

  .actual {
    margin-top: 1%;
  }

  .oee {
    margin-bottom: 1%;
  }

  @media (max-width: ${BREAKPOINT_MOBLET}px) {
    font-size: 9pt;
  }
`;

export const ShiftRowStyles = styled.div`
  width: 100%;
  position: relative;

  .shift-row {
    margin-bottom: 1%;
    display: flex;
    flex-direction: row;
    position: relative;
  }
  .day-row {
    background-color: #e6e7e8;
  }
  .night-row {
    background-color: rgb(39, 170, 225, 0.25);
    margin-bottom: 1%;
  }
  .shift-row-inner {
    width: 100%;
  }
  .shift-name-subtitle {
    transform: rotate(-90deg);
  }

  .subtitle-wrapper {
    position: absolute;
    height: 100%;
    width: 10%;
    display: flex;
    justify-content: center;
  }

  @media (max-width: ${BREAKPOINT_MOBLET}px) {
    .shift-name-subtitle {
      font-size: 8pt;
    }
  }
`;

export const WeekToDateStyles = styled.div`
  font-family: "Open Sans";
  min-width: 1024px; /* below this width, the report's numbers start to overlap */
  margin: 1em;

  @media print {
    @page {
      size: landscape;
      margin: 0;
    }
  }

  @media (max-width: ${BREAKPOINT_MOBLET}px) {
    width: 100%;
    margin: 0;
  }

  .row-label-column {
    position: relative;

    width: ${ROW_LABEL_COLUMN_WIDTH}%;
    text-align: center;
  }
  .day-column {
    padding-right: 1%;
    width: ${DAY_COLUMN_WIDTH}%;
    text-align: right;
  }
  .total-column {
    width: ${TOTAL_COLUMN_WIDTH}%;
    text-align: right;
  }

  .column-header {
    color: #999999;
  }
`;

export const CustomHeaderStyle = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10pt;
  width: 100%;
  height: 100%;
  box-sizing: border-box;

  .text {
    position: relative;
    line-height: 1;
    width: 100%;
    color: white;
    text-align: center;
  }
  .main-content {
    font-size: 64px;
  }
  .small-percent {
    font-size: 16px;
    padding-left: 2px;
  }

  @media (max-width: ${BREAKPOINT_MOBLET}px) {
    .main-content {
      font-size: 48px;
    }
  }
`;
